module.exports = __webpack_public_path__ + "img/success-icon.9d7df47d.svg";